import httpClient from './httpClient';
import {Apis} from "./Apis";

export const CouponService = {

  async getCouponPrintHistory(params = {}) {
    const path = '/coupon-print-job/last';
    let res = await httpClient.get(Apis.PC + path, {params: params});
    return res.data;
  },

  async getCouponTypeActive(salaId){
    const path = '/coupon-type/active';
    let res = await httpClient.get(Apis.PC + path, {params: {salaId}});
    return res.data;
  },

  async buildAndPrint(couponPrintJobForm) {
    const path = '/coupon-print-job/build-n-print';
    let res = await httpClient.post( Apis.PC + path, couponPrintJobForm);
    return res.data;
  },

  async checkState(couponPrintJobId) {
    const path = `/coupon-print-job/${couponPrintJobId}/state/v2`;
    let res = await httpClient.get(Apis.PC + path);
    return res.data;
  },

  async retryCouponPrintJob(couponPrintJobId) {
    const path = `/coupon-print-job/${couponPrintJobId}/retry`;
    let res = await httpClient.post(Apis.PC + path);
    return res.data;
  }
};
